/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { ExtendedWarranty } from "~/ProductDetails/ProductDetailPageResult";
import ExtendedWarrantyModal from "./ExtendedWarrantyModal";
import { WarrantyOption } from "~/common/AddToCartModal";
import ValidationError from "../../ValidationError";
import { getValidationError, groupingSelected } from "../../validations";
import { PricingProduct } from "~/ProductDetails/Pricing/PricingProduct";
import ExtendedWarrantyComponent from "./ExtendedWarrantyComponent";
interface Props {
  product: PricingProduct;
  hasSelectedGroupMember: boolean;
  handleAddToCartError: (validationError: ValidationError | undefined) => void;
  handleSetErrorMessage: (errorMessage: string) => void;
  selectedWarranty?: ExtendedWarranty;
  onSubmit: (result: WarrantyOption) => void;
}
const ExtendedWarrantyContainer = ({
  product,
  hasSelectedGroupMember,
  handleAddToCartError,
  handleSetErrorMessage,
  selectedWarranty,
  onSubmit
}: Props) => {
  const {
    extendedWarranties,
    isThirdPartyExtendedWarrantyEligible
  } = product;
  const extendedWarrantyRefs: HTMLInputElement[] = [];
  const warrantyHelpTextThirdParty = "By purchasing additional product protection, you are choosing to extend / supplement the existing manufacturer's warranty " + "that comes with this product, if any. Product protection from Safeware can provide a longer period of coverage as well as include " + "a wider range of coverage.\n For more details on the manufacturer's warranty, please refer to the warranty information below " + "in the Resources and Downloads section of this page.";
  const warrantyHelpText = "By purchasing an extended warranty, you are choosing to extend / supplement the existing manufacturer's warranty " + "that comes with this product, if any. Extended warranties can provide a longer period of coverage as well as include " + "a wider range of coverage.\n For more details on the manufacturer's warranty, please refer to the warranty information below " + "in the Resources and Downloads section of this page.";
  const extendedWarranty = extendedWarranties[0];
  const extendedWarrantyContent = extendedWarranty && extendedWarranty.isThirdParty && isThirdPartyExtendedWarrantyEligible ? warrantyHelpTextThirdParty : warrantyHelpText;
  const handleAddProtection = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const validationError = getValidationError({
      product,
      quantity: 1,
      validationsToRun: [groupingSelected]
    });
    if (validationError && validationError.message?.length > 0) {
      handleSetErrorMessage(validationError.message);
      handleAddToCartError(validationError);
    }
  };
  const handleRemoveProtection = (event: React.SyntheticEvent) => {
    event.preventDefault();
    onSubmit({
      warrantyId: 0
    });
  };
  const handleSubmit = (result: WarrantyOption) => {
    onSubmit(result);
  };
  return <>
      <ExtendedWarrantyComponent hasSelectedGroupMember={hasSelectedGroupMember} handleAddProtection={handleAddProtection} handleRemoveProtection={handleRemoveProtection} product={product} selectedWarranty={selectedWarranty} warrantyInfo={extendedWarrantyContent} data-sentry-element="ExtendedWarrantyComponent" data-sentry-source-file="ExtendedWarrantyContainer.tsx" />
      <ExtendedWarrantyModal extendedWarranties={extendedWarranties} extendedWarrantyRefs={extendedWarrantyRefs} isThirdPartyExtendedWarrantyEligible={isThirdPartyExtendedWarrantyEligible} onSubmit={handleSubmit} submitModal={() => ({})} closeModal={() => ({})} selectedWarranty={selectedWarranty} data-sentry-element="ExtendedWarrantyModal" data-sentry-source-file="ExtendedWarrantyContainer.tsx" />
    </>;
};
export default ExtendedWarrantyContainer;